import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the SPA. Defaults are tuned for a builder-supervision
 * app: data is rarely stale within a session, fetching on focus is intrusive
 * during day-to-day work on a construction site, and retries don't help when
 * the API container is genuinely down.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
